<template>
<v-layout v-resize="onResize" column>
  <v-data-table flat
    :headers="headers"
    :items="resources"
    class="elevation-2"
    :loading="isLoading"
    :total-items="resourcesCount"
    :rows-per-page-items="limitOptions"
    :pagination.sync="pagination"
    :hide-headers="isMobile" :class="{mobile: isMobile}"
  >
    <template slot="items" slot-scope="props">
      <tr v-if="!isMobile">
                  <td class="text-xs-left">{{ props.item.id }}</td>
                  <td class="text-xs-left">{{ props.item.payer_name }}</td>
                  <td class="text-xs-left">{{ props.item.bill_number }}</td>
                  <td class="text-xs-left">{{ $n((props.item.amount), 'currency') }}</td>
                  <td class="text-xs-left">
                    <v-chip :class="setClass(props.item.status)" small text-color="white">
                      {{ $t(`status.${props.item.status}`) }}
                    </v-chip>
                  </td>
                  <td class="text-xs-left">
                    <span v-if="props.item.due_date_bill && isValidDate(props.item.due_date_bill)">{{ $d(parseDate(props.item.due_date_bill), 'short') }}</span>
                    <span v-else class="text--secondary">-</span>
                  </td>
                  <td class="text-xs-left">{{ $d(new Date(props.item.created_at), 'short') }}</td>
                  <td class="text-xs-left">
                    <div class="d-flex flex-column">
                      <router-link :to="{ name: 'bill-payment', params: { id: props.item.id }}" class="mb-1">
                        <v-btn small text color="primary">
                          <v-icon left small>visibility</v-icon>
                          Exibir
                        </v-btn>
                      </router-link>
                      <template v-if="canDownload(props.item)">
                        <v-btn 
                          small 
                          text 
                          color="success"
                          @click="downloadBoleto(props.item)"
                          :loading="downloadingId === props.item.id"
                        >
                          <v-icon left small>get_app</v-icon>
                          Download
                        </v-btn>
                      </template>
                      <template v-else>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <span v-on="on" v-bind="attrs" class="text--disabled">
                              <v-icon small color="grey">get_app</v-icon>
                              PDF indisponível
                            </span>
                          </template>
                          <span>O PDF ficará disponível assim que o registro do boleto estiver completo em alguns instantes.</span>
                        </v-tooltip>
                      </template>
                    </div>
                  </td>
                </tr>
                <tr v-else>
                  <td>
                    <ul class="flex-content">
                      <li class="flex-item" data-label="ID Boleto">{{ props.item.id }}</li>
                      <li class="flex-item" data-label="Nome Pagador">{{  props.item.payer_name }}</li>
                      <li class="flex-item" data-label="Nosso Número">{{ props.item.bill_number }}</li>
                      <li class="flex-item" data-label="Valor">{{ $n((props.item.amount), 'currency') }}</li>
                      <li class="flex-item" data-label="Status">
                        <v-chip :class="setClass(props.item.status)" small text-color="white">
                          {{ $t(`status.${props.item.status}`) }}
                        </v-chip>
                      </li>
                      <li class="flex-item" data-label="Vencimento">
                        <span v-if="props.item.due_date_bill && isValidDate(props.item.due_date_bill)">{{ $d(parseDate(props.item.due_date_bill), 'short') }}</span>
                        <span v-else class="text--secondary">-</span>
                      </li>
                      <li class="flex-item" data-label="Criado em">{{ $d(new Date(props.item.created_at), 'short') }}</li>
                      <li class="flex-item" data-label="Ações">
                        <div class="d-flex flex-column">
                          <router-link :to="{ name: 'bill-payment', params: { id: props.item.id }}" class="mb-2">
                            <v-btn small text color="primary">
                              <v-icon left small>visibility</v-icon>
                              Exibir
                            </v-btn>
                          </router-link>
                          <template v-if="canDownload(props.item)">
                            <v-btn 
                              small 
                              text 
                              color="success"
                              @click="downloadBoleto(props.item)"
                              :loading="downloadingId === props.item.id"
                            >
                              <v-icon left small>get_app</v-icon>
                              Download
                            </v-btn>
                          </template>
                          <template v-else>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <span v-on="on" v-bind="attrs" class="text--disabled">
                                  <v-icon small color="grey">get_app</v-icon>
                                  PDF indisponível
                                </span>
                              </template>
                              <span>O PDF ficará disponível assim que o registro do boleto estiver completo em alguns instantes.</span>
                            </v-tooltip>
                          </template>
                        </div>
                      </li>
                    </ul>
                  </td>
                </tr>


    </template>
  </v-data-table>
  </v-layout>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { changed } from "@/helpers/layout";

export default {
  mounted() {
    this.$store.dispatch("bills/loadBills", this.filters);
  },
  computed: {
    ...mapGetters({
      resources: "bills/billsList",
      resourcesCount: "bills/billsResourcesCount",
      limitOptions: "bills/billsLimitOptions",
      limit: "bills/billsLimit",
      currentPage: "bills/billsCurrentPage",
      filters: "bills/billsFilter",
      isLoading: "bills/billsLoadingData",
    }),
    // pages() {
    //   return 0;
    // },
  },
  components: {
    // Removed unused components
  },
  watch: {
    pagination: function pagination(newPagination, oldPagination) {
      if( changed(newPagination.rowsPerPage, oldPagination.rowsPerPage) ) {
        this.setLimit(newPagination.rowsPerPage);
        this.$store.dispatch("bills/loadBills", this.filters);
      }
      if( changed(newPagination.page, oldPagination.page) ) {
        this.setCurrentPage(newPagination.page);
        this.$store.dispatch("bills/loadBills", this.filters);
      }
    },
  },
  methods: {
    ...mapActions({
      setCurrentPage: "bills/setBillsCurrentPage",
      setLimit: "bills/setBillsLimit",
    }),
    setChipColor(color) {
      return this.$t(`colors.${color}`);
    },
    setClass(status) {
      return `invoice ${status}`;
    },
    onResize() {
      if (window.innerWidth < 769)
        this.isMobile = true;
      else
        this.isMobile = false;
    },
    isValidDate(dateString) {
      if (!dateString) return false;

      // Check for common invalid date patterns
      const date = new Date(dateString);
      const timestamp = date.getTime();

      // Check if date is valid and not the Unix epoch (1970-01-01)
      return !isNaN(timestamp) && timestamp > 86400000; // Greater than 1 day after epoch
    },
    parseDate(dateString) {
      if (!dateString) return new Date();

      // Handle ISO date format (YYYY-MM-DD)
      if (dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
        // Add time component to avoid timezone issues
        return new Date(dateString + 'T12:00:00');
      }

      // Handle ISO datetime format
      return new Date(dateString);
    },
    canDownload(bill) {
      // Check if bill has necessary data for PDF generation
      return bill.bill_number && 
             bill.status !== 'processing' && 
             bill.digitable_line;
    },
    async downloadBoleto(bill) {
      try {
        this.downloadingId = bill.id;
        
        // Use store dispatch to download PDF
        const result = await this.$store.dispatch('bills/downloadPdf', bill.id);
        
        if (result && result.success) {
          // Create blob and download
          const blob = new Blob([result.data], { type: 'application/pdf' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = `boleto-${bill.id}.pdf`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
          
          // Show success message
          console.log('Boleto baixado com sucesso!');
        } else {
          console.error('Erro ao baixar o boleto. Tente novamente.');
        }
      } catch (error) {
        console.error('Erro ao baixar boleto:', error);
      } finally {
        this.downloadingId = null;
      }
    },
  },
  data() {
    return {
      items: [],
      count: 0,
      pagination: {},
      isMobile: false,
      downloadingId: null,
      headers: [
        { text: "Id Boleto", value: "id" },
        { text: "Nome Pagador", value: "payer_name" },
        { text: "Nosso Número", value: "bill_number" },
        { text: "Valor", value: "amount" },
        { text: "Status", value: "status" },
        { text: "Vencimento", value: "due_date_bill" },
        { text: "Criado em", value: "created_at" },
        { text: "Ações", value: "actions", sortable: false },
      ],
    };
  },
};
</script>
<style>
.mobile {
      color: #333;
    }

    @media screen and (max-width: 768px) {
      .mobile table.v-table tr {
        max-width: 100%;
        position: relative;
        display: block;
      }

      .mobile table.v-table tr:nth-child(odd) {
        border-left: 6px solid #b2b2b8;
      }

      .mobile table.v-table tr:nth-child(even) {
        border-left: 6px solid #636366;
      }

      .mobile table.v-table tr td {
        display: flex;
        width: 100%;
        border-bottom: 1px solid #f5f5f5;
        height: auto;
        padding: 10px;
      }

      .mobile table.v-table tr td ul li:before {
        content: attr(data-label);
        padding-right: .5em;
        text-align: left;
        display: block;
        color: #999;

      }
      .v-datatable__actions__select
      {
        width: 50%;
        margin: 0px;
        justify-content: flex-start;
      }
      .mobile .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
        background: transparent;
      }

    }
    .flex-content {
      padding: 0;
      margin: 0;
      list-style: none;
      display: flex;
      flex-wrap: wrap;
      width: 100%;
    }

    .flex-item {
      padding: 5px;
      width: 50%;
      height: 40px;
      font-weight: bold;
      margin-top: 10px;
    }
  .v-chip.invoice.cancelled    { background-color: #B71C1C !important; }
  .v-chip.invoice.completed    { background-color: #1B5E20 !important; }
  .v-chip.invoice.waiting       { background-color: #EF6C00 !important; }
  .v-chip.invoice.processing   { background-color: var(--primary-color, #1976D2) !important; }
</style>
